import React from 'react';
import { NotificationType, useAppState } from '../../context/appContext';
import InfoBox from '../../components/common/InfoBox';
import { LinkButton } from '../../components/common';
import { getMenuItemPathBySlug } from '../../utils/wordpress';
import { Slugs } from '../../constants/knownSlugs';
import { useMessageGetter } from 'react-message-context';
import { Routes } from '../../constants/routes';
import { ButtonContainer } from '../layoutComponents';

interface InfoBoxProps {
  message: string;
}

const Submitted: React.FC<InfoBoxProps> = ({ message }) => {
  const { menu } = useAppState();
  const t = useMessageGetter('');

  return (
    <>
      <InfoBox type={NotificationType.INFO} message={message} />
      <ButtonContainer>
        <LinkButton to={getMenuItemPathBySlug(menu.items, Slugs.COMMITTEE)} size="medium" primary>
          {t('living.committee.title')}
        </LinkButton>
        <LinkButton to={Routes.OwnForms.ALL_FORMS} size="medium">
          {t('ownForms.title')}
        </LinkButton>
      </ButtonContainer>
    </>
  );
};

export default Submitted;
